const MEMBER_PATHS = new Set(["/agent", "/p", "/referrals", "/billing"]);
const VISITOR_KEY = "mincool.funnelVisitor";

export function funnelVisitorId({ create = false, store = globalThis.window?.sessionStorage, uuid = () => crypto.randomUUID() } = {}) {
  if (!store) return "";
  const existing = store.getItem(VISITOR_KEY);
  if (existing || !create) return existing || "";
  const id = uuid();
  store.setItem(VISITOR_KEY, id);
  return id;
}

export function referralCodeFromLocation(location = {}) {
  const match = String(location.pathname || "").match(/^\/m\/([^/]+)\/?$/);
  try {
    return String(match ? decodeURIComponent(match[1]) : new URLSearchParams(location.search || "").get("ref") || "").trim();
  } catch {
    return "";
  }
}

export function safeMemberDestination(value) {
  const path = String(value || "");
  const pathname = path.split("?")[0];
  return MEMBER_PATHS.has(pathname) && !path.includes("\\") && !path.includes("#") ? path : "";
}
